var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolaVacunas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#EABE00;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bola-revision") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    className: "st0",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-338.000000, -412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "datos-paciente",
    transform: "translate(298.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-vacunas",
    transform: "translate(40.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st1",
    d: "M9.4,19h8.1v-0.4c0-1-0.8-1.9-1.8-1.9c-0.4,0-0.7-0.3-0.7-0.8v-0.8H12V16 c0,0.4-0.3,0.8-0.7,0.8c-1,0-1.8,0.8-1.8,1.9V19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.3,13h-3.7c-0.2,0-0.4,0.2-0.4,0.4v1.1h4.4v-1.1C15.7,13.1,15.5,13,15.3,13z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "13.1,23.2 13.1,24.3 13.8,24.3 13.8,23.2 14.9,23.2 14.9,22.4 13.8,22.4 13.8,21.3 13.1,21.3  13.1,22.4 12,22.4 12,23.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.4,27.7c0,0.2,0.2,0.4,0.4,0.4h7.4c0.2,0,0.4-0.2,0.4-0.4v-1.1H9.4V27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st1",
    d: "M9.4,25.8h8.1v-6.1H9.4V25.8z M11.2,22c0-0.2,0.2-0.4,0.4-0.4h0.7v-0.8 c0-0.2,0.2-0.4,0.4-0.4h1.5c0.2,0,0.4,0.2,0.4,0.4v0.8h0.7c0.2,0,0.4,0.2,0.4,0.4v1.5c0,0.2-0.2,0.4-0.4,0.4h-0.7v0.8 c0,0.2-0.2,0.4-0.4,0.4h-1.5c-0.2,0-0.4-0.2-0.4-0.4v-0.8h-0.7c-0.2,0-0.4-0.2-0.4-0.4V22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.4,11.8v11h4.4v-2.3H23c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.8V19h-1.1c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4h1.1v-0.8H23c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h1.8V16h-1.1c-0.2,0-0.4-0.2-0.4-0.4 c0-0.2,0.2-0.4,0.4-0.4h1.1v-0.8H23c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.8V13h-1.1c-0.2,0-0.4-0.2-0.4-0.4 c0-0.2,0.2-0.4,0.4-0.4h1.1v-0.4c0-0.2-0.2-0.4-0.4-0.4h-3.7C20.6,11.4,20.4,11.6,20.4,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.8,28.1h3.7c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4h-3.7c-0.2,0-0.4,0.2-0.4,0.4S20.6,28.1,20.8,28.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.7,23.9c0,0.2,0.2,0.4,0.4,0.4h5.2c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-5.2 C19.9,23.6,19.7,23.7,19.7,23.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.9,25.1 23.4,25.1 23.4,26.6 21.9,26.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,9.9V7.3c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4v2.6c-0.2,0-0.4,0.2-0.4,0.4v0.4h1.5v-0.4 C23.4,10.1,23.2,9.9,23,9.9z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolaVacunas);
export default __webpack_public_path__ + "static/media/bola-vacunas.2d10b7925e4508372d61093c149202e6.svg";
export { ForwardRef as ReactComponent };